import { useAuth } from "@/context/AuthContext";
import ShiftStatusPill from "./ShiftStatusPill";

/**
 * Wrapper that pulls user from context so the pill can be dropped globally in
 * App.js without every route knowing about auth.
 */
export default function ShiftStatusPillGlobal() {
  const { user } = useAuth();
  if (!user) return null;
  return <ShiftStatusPill user={user} />;
}
